import styles from './LoadingScreen.module.css';

interface LoadingScreenProps {
  message?: string;
}

export function LoadingScreen({ message = 'Loading...' }: LoadingScreenProps) {
  const isLight = typeof document !== 'undefined' && (
    document.documentElement.getAttribute('data-theme') === 'light' ||
    localStorage.getItem('theme') === 'light'
  );
  const logoSrc = '/logo-icon-light.png';

  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <div className={styles.logoMark}>
          <img src={logoSrc} alt="JOBNVISA" style={{ height: '22px', width: 'auto', objectFit: 'contain', background: 'none', border: 'none' }} />
        </div>
        <div className={styles.spinner} aria-label="Loading" role="status" />
        <p className={styles.message}>{message}</p>
      </div>
    </div>
  );
}
